import ArrowLink from './ArrowLink';

export { type ArrowLinkProps } from './ArrowLink';
export default ArrowLink;
